<template>
  <Wrapper>
    <Topo logado />
    <MenuLateral />
    <InternaMain
      :class="$vuetify.breakpoint.smAndDown ? 'padding-b' : 'pb-12'"
      maxwidth-container="610px"
    >
      <TituloPagina :titulo="tituloPagina" class="pt-7 pt-md-9" />
      <p class="primary--text mt-5">
        Para melhor te ajudar, descreva abaixo a sua justificativa
        sobre não concordar com o vendedor.
      </p>
      <FormDescricaoMotivo
        :codigo-venda="codigoVenda"
        :codigo-reembolso="codigoReembolso"
        :codigo-motivo="codigoMotivo"
        :url-envio="urlEnvio"
        observacao-obrigatorio
        @respostaApi="trataRespostaApi"
      />
      <ModalResposta
        :dialog="dialog"
        :titulo="tituloPagina"
        :url-btn-fechar="urlDetalheCompra"
      >
        <template v-slot:texto>
          <template v-if="!sucesso">
            Desculpe, ocorreu um erro. Por favor, tente novamente mais tarde.
          </template>
          <template v-else-if="dadosCompra.possuiProdutoFisico">
            Resposta enviada com sucesso! Iremos verificar ambas as justificativas e
            auxiliar em seu problema. Pedimos que aguarde até 5 dias para darmos
            um retorno sobre a solicitação.
          </template>
          <template v-else-if="cartaoCredito">
            A sua solicitação de reembolso foi acatada. <br>
            Em breve, a adquirente irá realizar o estorno do valor
            no cartão de crédito utilizado na compra.
          </template>
          <template v-else>
            A sua solicitação de reembolso foi acatada. <br>
            Em breve, entraremos em contato para confirmar
            que o valor foi depositado na conta informada.
          </template>
        </template>
      </ModalResposta>
    </InternaMain>
  </Wrapper>
</template>

<script>
import Wrapper from '@/components/Wrapper.vue';
import Topo from '@/components/Topo.vue';
import MenuLateral from '@/components/MenuLateral.vue';
import InternaMain from '@/components/InternaMain.vue';
import TituloPagina from '@/components/TituloPagina.vue';
import FormDescricaoMotivo from '@/components/AcompanharSolicitacao/FormDescricaoMotivo.vue';
import ModalResposta from '@/components/ModalResposta.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'ObservacoesDiscordar',

  components: {
    Wrapper,
    Topo,
    MenuLateral,
    InternaMain,
    TituloPagina,
    FormDescricaoMotivo,
    ModalResposta,
  },

  data() {
    return {
      tituloPagina: 'Discordo do vendedor',
      urlEnvio: 'refund-request/disagree',
      sucesso: false,
      dialog: false,
      codigoVenda: 1,
      codigoReembolso: 1,
      codigoMotivo: 1,
      urlDetalheCompra: '/minhas-compras/detalhe-compra/',
    };
  },

  computed: {
    ...mapGetters(['dadosCompra']),

    cartaoCredito() {
      return this.dadosCompra.cartaoCredito && !this.dadosCompra.is_online_debt;
    },

  },

  created() {
    if (this.dadosCompra.reembolsoStatus !== 'aguardando-resposta-consumidor' || !this.dadosCompra.category) {
      const pagina = this.$router.go ? this.$router.go(-1) : '/minhas-compras';
      return this.$router.push(pagina);
    }

    if (!this.dadosCompra) {
      return this.dadosCompra;
    }

    this.codigoVenda = this.dadosCompra.venda;
    this.codigoReembolso = this.dadosCompra.codigoReembolso;
    this.codigoMotivo = this.dadosCompra.category;
    this.urlDetalheCompra += this.codigoVenda;
    return this.dadosCompra;
  },

  methods: {
    trataRespostaApi(sucesso) {
      this.sucesso = sucesso;
      this.dialog = true;
    },
  },

};
</script>

<style lang="scss" scoped>
.padding-b { padding-bottom: 70px !important; }
</style>
